/** Save a string as a file from the browser. */
export function downloadText(filename: string, text: string, type = "text/csv") {
	const url = URL.createObjectURL(new Blob([text], { type }));
	const link = document.createElement("a");
	link.href = url;
	link.download = filename;
	link.click();
	URL.revokeObjectURL(url);
}
